import React from 'react';

export const HelloTest: React.FC = () => {
  return (
    <div style={{
      padding: '40px',
      fontFamily: 'sans-serif',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <h1 style={{ color: '#2563eb', fontSize: '32px', marginBottom: '20px' }}>
        ✅ Hello World - Test Page Working!
      </h1>
      <p style={{ fontSize: '18px', marginBottom: '16px' }}>
        If you can see this page, then:
      </p>
      <ul style={{ fontSize: '16px', lineHeight: '1.8' }}>
        <li>✅ React Router is working</li>
        <li>✅ TypeScript compilation is working</li>
        <li>✅ The dev server is running</li>
        <li>✅ New pages can be added successfully</li>
      </ul>
      <div style={{
        marginTop: '40px',
        padding: '20px',
        backgroundColor: '#f0f9ff',
        borderRadius: '8px',
        border: '2px solid #2563eb'
      }}>
        <h2 style={{ fontSize: '20px', marginBottom: '12px' }}>Next Step:</h2>
        <p style={{ fontSize: '16px' }}>
          Once this works, we'll debug the CSS issue with the main Dashboard.
        </p>
      </div>
      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <p>Current time: {new Date().toLocaleTimeString()}</p>
        <p>Route: /hello-test</p>
      </div>
    </div>
  );
};
